import Nofound from ".././components/console/Nofound.vue";
import Login from ".././components/console/Login.vue";
import Iframe from ".././components/console/Iframe.vue";
import Main from ".././components/console/main/Main.vue";
import MenuTree from ".././components/console/main/MenuTree.vue";
import SectionList from ".././components/console/main/SectionList.vue";
import RoleList from ".././components/console/main/RoleList.vue";
import AdminList from ".././components/console/main/AdminList.vue";
import AdminEditInfo from ".././components/console/main/AdminEditInfo.vue";
import AdminEditPwd from ".././components/console/main/AdminEditPwd.vue";
import Config from ".././components/console/main/Config.vue";
import appVersionset from ".././components/console/main/appVersionset.vue";
import Lists from ".././components/console/main/Lists.vue";
import ListType from ".././components/console/main/ListType.vue";
import Pages from ".././components/console/main/Pages.vue";
import Qrcode from ".././components/console/main/Qrcode.vue";
import PagesCreate from ".././components/console/main/PagesCreate.vue";
// 百家姓
import baijiaxingIdex from ".././components/console/tm_manghe/baijiaxing/index.vue"
import baijiaxingCreateBiaoGe from ".././components/console/tm_manghe/baijiaxing/createBiaoge.vue"
import baijiaxingBiaoge from ".././components/console/tm_manghe/baijiaxing/biaoge.vue"
// 专题
import zhuantiList from ".././components/console/tm_zhuanti/list.vue";
import zhuantiIndex from ".././components/console/tm_zhuanti/index.vue";
import zhuanticomment from ".././components/console/tm_zhuanti/zhuanticomment.vue";
// 广告
import AdPos from ".././components/console/main/AdPos.vue";
//excel导出
import ExcelExport from ".././components/console/main/ExcelExport.vue";
import Ad from ".././components/console/main/Ad.vue";
import Company from ".././components/console/exchangepoints/Company.vue";
import TongBuGoodOrder from ".././components/console/exchangepoints/TongBuGoodOrder.vue";
import ExchangeSet from ".././components/console/exchangepoints/ExchangeSet.vue";
import PointsLog from ".././components/console/exchangepoints/PointsLog.vue";

// 商城
import GoodsList from ".././components/console/tm_good/GoodsListNew.vue";
import SaleGoods from ".././components/console/tm_good/SaleGoods.vue";
import ProductProcess from ".././components/console/tm_good/ProductProcess.vue";
import GoodCate from ".././components/console/tm_good/GoodCate.vue";
import SaleGoodCate from ".././components/console/tm_good/SaleGoodCate.vue";
import GoodBrand from ".././components/console/tm_good/GoodBrand.vue";
import GoodAtrr from ".././components/console/tm_good/GoodAtrr.vue";
import SaleInvoiceRule from ".././components/console/tm_good/SaleInvoiceRule.vue";
import GoodsOrder from ".././components/console/tm_good/GoodsOrder.vue";
import GoodsZtOrder from ".././components/console/tm_good/GoodsZtOrder.vue";
import ReturnOrder from ".././components/console/tm_good/ReturnOrder.vue";
import Applylog from ".././components/console/tm_consume/Applylog.vue";
import TradMoneylog from ".././components/console/tm_consume/TradMoneylog.vue";
import SellerMoneylog from ".././components/console/tm_consume/SellerMoneylog.vue";
import GoodCommentList from ".././components/console/tm_good/GoodCommentList.vue";

// 快递列表
import LogisticList from ".././components/console/tm_good/LogisticList.vue";

// 会员发票
import UserInvoice from ".././components/console/tmuser/UserInvoice.vue";
// 会员管理
import UserList from ".././components/console/tmuser/UserList.vue";
// 会员消费
import UserConsume from "../components/console/tmuser/UserConsume.vue";
// 注销记录
import ConcelLog from "../components/console/tmuser/ConcelLog.vue";
// 会员地址
import UserAddress from ".././components/console/tmuser/UserAddress.vue";
// 分组
import UserGroup from ".././components/console/tmuser/UserGroup.vue";
// 匠人相关
import TradesmanList from ".././components/console/tmuser/TradesmanList.vue";
import TradesmanCateList from ".././components/console/tmuser/TradesmanCateList.vue";
import TradesmanThumbCateList from ".././components/console/tmuser/TradesmanThumbCateList.vue";
import TradesmanThumbList from ".././components/console/tmuser/TradesmanThumbList.vue";
import TradesmanSkillList from ".././components/console/tmuser/TradesmanSkillList.vue";
import TradesmanSorce from ".././components/console/tmuser/TradesmanSorce.vue";
import ReviewTradesmanList from ".././components/console/tmuser/ReviewTradesmanList.vue";
import TradesmanThumbCommentList from ".././components/console/tmuser/TradesmanThumbCommentList.vue";
// 热门搜索
import SellerList from ".././components/console/tmuser/SellerList.vue";
import Agents from ".././components/console/tmuser/Agents.vue";
import QrcodeUser from ".././components/console/tmuser/QrcodeUser.vue";
import AgentsUserList from ".././components/console/tmuser/AgentsUserList.vue";
import AgentsTradesmanList from ".././components/console/tmuser/AgentsTradesmanList.vue";
import AgentsTcRecordList from ".././components/console/tmuser/AgentsTcRecordList.vue";
import Partners from ".././components/console/tmuser/Partners.vue";
import PartnersAgent from ".././components/console/tmuser/PartnersAgentList.vue";
import PartnersTradesmanList from ".././components/console/tmuser/PartnersTradesmanList.vue";
import PartnersTcRecordList from ".././components/console/tmuser/PartnersTcRecordList.vue";
// 热门搜索
import SearchData from ".././components/console/hotsearch/SearchData.vue";
// 专题
import Special from ".././components/console/tm_special/Special.vue";
import SpecialTrad from ".././components/console/tm_special/SpecialTrad.vue";

// 项目相关
import IntangibleCate from ".././components/console/tm_intangible/IntangibleCate.vue";
import IntangibleLevel from ".././components/console/tm_intangible/IntangibleLevel.vue";
import IntangibleItem from ".././components/console/tm_intangible/IntangibleItem.vue";
import ItemType from ".././components/console/tm_intangible/ItemType.vue";
import IntangibleLocation from ".././components/console/tm_intangible/IntangibleLocation.vue";
import LocationErrors from ".././components/console/tm_intangible/LocationErrors.vue";
import LocationComments from ".././components/console/tm_intangible/LocationComments.vue";
import Area from ".././components/console/tm_intangible/Area.vue";
import NoteConfig from ".././components/console/tm_chargeCard/NoteConfig.vue";
import LocationNote from ".././components/console/tm_chargeCard/LocationNote.vue";
import HotItemLocation from ".././components/console/tm_intangible/BigMap/HotItemLocation.vue";
import HeatArea from ".././components/console/tm_intangible/BigMap/HeatArea.vue";
// 员工分组
import StaffGroup from ".././components/console/tm_chargeCard/StaffGroup.vue";
import Staff from ".././components/console/tm_chargeCard/Staff.vue";
import ChargeCard from ".././components/console/tm_chargeCard/ChargeCard.vue";
// 商家管理
// 菜单
import merchantMenuList from ".././components/console/tm_trade_manage/MerchantMenuList.vue";
import merchantRoleList from ".././components/console/tm_trade_manage/MerchantRoleList.vue";
// 约看
import Lives from ".././components/console/tm_lives/Lives.vue";
import LiveRoomType from ".././components/console/tm_lives/LiveRoomType.vue";
import LivesType from ".././components/console/tm_lives/LivesType.vue";
// 约看订单
import LivesOrder from ".././components/console/tm_lives/LivesOrder.vue";

// 园区
import ParkList from ".././components/console/tmuser/ParkList.vue";
import ParkLevelList from ".././components/console/tmuser/ParkLevelList.vue";
import ParkTradesmanList from ".././components/console/tmuser/ParkTradesmanList.vue";
import ParkPendTradList from ".././components/console/tmuser/ParkPendTradList.vue";
import ParkTcRecordList from ".././components/console/tmuser/ParkTcRecordList.vue"; // 园区收入记录
import ParkMoneyStatistics from ".././components/console/tmuser/ParkMoneyStatistics.vue";
import ParkTxList from ".././components/console/tmuser/ParkTxList.vue"; // 园区体现记录

// 代理商
import ParkAgent from ".././components/console/tmuser/ParkAgentList.vue";
import ParkPendAgent from ".././components/console/tmuser/ParkPendAgent.vue";
import ParkPendFirstAgent from ".././components/console/tmuser/ParkPendFirstAgent.vue";
//直播
import LiveRoomList from ".././components/console/tm_liveroom/LiveRoomList.vue";
//回放
import LiveRoomCallBack from ".././components/console/tm_liveroom/LiveRoomCallBack.vue";
import LiveRoomCallBackComment from ".././components/console/tm_liveroom/LiveRoomCallBackComment.vue";

//视频列表
import LiveVideoList from ".././components/console/tm_liveroom/LiveVideoList.vue";
//章节
import LiveVideosChapter from ".././components/console/tm_liveroom/LiveVideosChapter.vue";
//视频订单
import LivesVideoOrder from ".././components/console/tm_liveroom/LivesVideoOrder.vue";

//头条
import HeadlinePushType from ".././components/console/tm_headline/HeadlinePushType.vue";
import HeadlineCate from ".././components/console/tm_headline/HeadlineCate.vue";
import Headline from ".././components/console/tm_headline/Headline.vue";
import HeadlineCommentList from ".././components/console/tm_headline/HeadlineCommentList.vue";
//历史的今天
import Historycate from ".././components/console/tm_history_today/Historycate.vue";
import History from ".././components/console/tm_history_today/History.vue";
import HistoryDaoJu from ".././components/console/tm_history_today/HistoryDaoJu.vue";
import HistoryComment from ".././components/console/tm_history_today/HistoryComment.vue";
//海报
import Poster from ".././components/console/tm_history_today/Poster.vue";
//漂流
import LoveDrift from ".././components/console/tm_history_today/LoveDrift.vue";
import LoveDriftComment from ".././components/console/tm_history_today/LoveDriftComment.vue";

//定制
import CustomMadeCate from ".././components/console/tm_customized/CustomMadeCate.vue";
import CustomMade from ".././components/console/tm_customized/CustomMade.vue";
import MadeOrder from ".././components/console/tm_customized/MadeOrder.vue";
import MadeComment from ".././components/console/tm_customized/MadeComment.vue";
//定制社区
import CustomCommunity from ".././components/console/tm_customized/CustomCommunity.vue";

//一级分销商
import FirstAgent from ".././components/console/tmuser/FirstAgent.vue";
import FirstAgentAgent from "../components/console/tmuser/FirstAgentAgentList.vue";
import FirstAgentTcRecordList from ".././components/console/tmuser/FirstAgentTcRecordList.vue";
import ParkFirstAgent from ".././components/console/tmuser/ParkFirstAgent.vue"; //园区下的一级分销商
import Salesman from ".././components/console/tmuser/Salesman.vue";
import SalesmanSaomaLog from ".././components/console/tmuser/SalesmanSaomaLog.vue";
//融宝账号
import reapalapply from ".././components/console/reapal/ReapalApply.vue";

// 消息
import systemMsg from ".././components/console/tm_msg/system.vue";
import customerMsg from ".././components/console/tm_msg/customer.vue";
import report from ".././components/console/tm_msg/report.vue";
//献礼
import XliSupportUnit from ".././components/console/tm_xianli/supportunit.vue";
import XliLinks from ".././components/console/tm_xianli/links.vue";
import XliArticle from ".././components/console/tm_xianli/article.vue";
import XliArticleComment from ".././components/console/tm_xianli/articlecomment.vue";

//匠人资讯
import tradesmanInformation from ".././components/console/tm_trade_manage/TradesmanInformation.vue";
//智慧园区
import TicketCollector from ".././components/console/tm_smartpark/TicketCollector.vue";
import SmartPark from ".././components/console/tm_smartpark/SmartPark.vue";
import TimesCard from ".././components/console/tm_smartpark/TimesCard.vue";
import SmartEnterinfo from ".././components/console/tm_smartpark/SmartEnterinfo.vue";
import SmartUserOrder from ".././components/console/tm_smartpark/SmartUserOrder.vue";
import SmartOrder from ".././components/console/tm_smartpark/SmartOrder.vue";
import TimeCardOrder from ".././components/console/tm_smartpark/TimeCardOrder.vue";
import SmartReceper from ".././components/console/tm_smartpark/SmartReceper.vue";
import SmartService from ".././components/console/tm_smartpark/SmartService.vue";
import SmartTicket from ".././components/console/tm_smartpark/SmartTicket.vue";
import SmartTicketPrice from ".././components/console/tm_smartpark/SmartTicketPrice.vue";
import SmartTicketType from ".././components/console/tm_smartpark/SmartTicketType.vue";
import SmartVenue from ".././components/console/tm_smartpark/SmartVenue.vue";
import TeamType from ".././components/console/tm_smartpark/TeamType.vue";
import SmartThroughTicket from ".././components/console/tm_smartpark/SmartThroughTicket.vue";

import StudyGruop from ".././components/console/tm_smartpark/StudyGruop.vue";
import StudyContent from ".././components/console/tm_smartpark/StudyContent.vue";
import VenueProduct from ".././components/console/tm_smartpark/VenueProduct.vue";
import SmartParkScreen from ".././components/console/tm_smartpark/screen/SmartParkScreen.vue";
import AppVersion from ".././components/console/tm_smartpark/AppVersion.vue";
//盲盒
import ProductPool from '.././components/console/tm_manghe/ProductPool/ProductPool.vue'
import ProductPoolCate from '.././components/console/tm_manghe/ProductPool/ProductPoolCate.vue'
import SetFare from '.././components/console/tm_manghe/ProductPool/SetFare.vue'
import GoodAtrrtag from '.././components/console/tm_manghe/ProductPool/GoodAtrrtag.vue'
import Data from '.././components/console/tm_manghe/Data.vue'
import ProductPoolGood from '.././components/console/tm_manghe/ProductPool/ProductPoolGood.vue'
import ProductPoolProbability from '.././components/console/tm_manghe/ProductPool/ProductPoolProbability.vue'
import HechengPoolGood from '.././components/console/tm_manghe/HeChengPools/HechengPoolGood.vue'
import HechengPoolData from '.././components/console/tm_manghe/HeChengPools/HechengPoolData.vue'
import HechengPoolProbability from '.././components/console/tm_manghe/HeChengPools/HechengPoolProbability.vue'
import HechengPoolRule from '.././components/console/tm_manghe/HeChengPools/HechengPoolRules.vue'
import MangheOrder from '.././components/console/tm_manghe/Order/MangheOrder.vue'
import MangheGoodsOrder from '.././components/console/tm_manghe/Order/GoodsOrder.vue'
import MangheDataOrder from '.././components/console/tm_manghe/Order/DataOrder.vue'
import MangheHuishouOrder from '.././components/console/tm_manghe/Order/HuishouOrder.vue'
import MangheFareOrder from '.././components/console/tm_manghe/Order/FareOrder.vue'
import Winner from '.././components/console/tm_manghe/Winner.vue'
//盲盒营销
import MangheColor from '../components/console/tm_manghe/Color/MangheColor.vue'
import MangheHomeColor from '.././components/console/tm_manghe/Color/MangheHomeColor.vue'
import MangheSet from '.././components/console/tm_manghe/made/MangheSet.vue'
import MangheWish from '.././components/console/tm_manghe/made/MangheWish.vue'
import MangheMadeOrder from '.././components/console/tm_manghe/made/MangheMadeOrder.vue'
import MangheMadeGoodsOrder from '.././components/console/tm_manghe/made/MangheMadeGoodsOrder.vue'
import Notice from '../components/console/tm_manghe/Notice.vue'
//盲盒商城
import MangheShopCate from '.././components/console/tm_manghe/shop/GoodCate.vue'
import MangheShopGoods from '.././components/console/tm_manghe/shop/Goods.vue'
import MangheShopGoodOrder from '.././components/console/tm_manghe/shop/GoodOrder.vue'
import MangheShopGoodReturnOrder from '.././components/console/tm_manghe/shop/GoodReturnOrder.vue'
import MangheShopPayOrder from '.././components/console/tm_manghe/shop/PayOrder.vue'
import ShopSet from '.././components/console/tm_manghe/shop/ShopSet.vue'
import ShopKeyword from '.././components/console/tm_manghe/shop/ShopKeyword.vue'

//数字产品
import Type from ".././components/console/tm_numpro/Type.vue";
import NumproCate from ".././components/console/tm_numpro/NumproCate.vue";
import Product from ".././components/console/tm_numpro/Product.vue";
import ShowRoom from ".././components/console/tm_numpro/ShowRoom.vue";
import CollectionChain from ".././components/console/tm_numpro/CollectionChain.vue";
import UnCollectionChain from ".././components/console/tm_numpro/UnCollectionChain.vue";
import Collector from ".././components/console/tm_numpro/Collector.vue";
import CollectionOrder from ".././components/console/tm_numpro/CollectionOrder.vue";
import TurnLog from ".././components/console/tm_numpro/TurnLog.vue";
import Exchange from ".././components/console/tm_numpro/Exchange.vue";
import CollectorRecord from ".././components/console/tm_numpro/CollectorRecord.vue";
//百姓墙
import Operator from '.././components/console/tm_manghe/BaiXingQiang/Operator.vue'
import ChouQuRule from '.././components/console/tm_manghe/BaiXingQiang/ChouQuRule.vue'
import BaiXingQiang from '.././components/console/tm_manghe/BaiXingQiang/Qiang.vue'
import BaiXingQiangPayOrder from '.././components/console/tm_manghe/BaiXingQiang/PayOrder.vue'
import BaiXingQiangGoodOrder from '.././components/console/tm_manghe/BaiXingQiang/GoodOrder.vue'
import BaiXingQiangSet from ".././components/console/tm_manghe/BaiXingQiang/QiangSet.vue"
import MangheQiangGoodReturnOrder from '.././components/console/tm_manghe/BaiXingQiang/GoodReturnOrder.vue'
// 媒资管理
import mediaCategory from "../components/console/media/Category.vue";
import mediaIndex from "../components/console/media/Index.vue";

import Share from ".././components/console/share.vue";

export default [
  // 登录
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  // 分享
  {
    path: "/share/index",
    name: "share-index",
    component: Share,
    meta: {
      requiresAuth: false,//是否需要登录验证
    },
  },
  // 内容的模板
  {
    path: "/",
    component: Iframe,
    meta: {
      requiresAuth: true,
    },
    children: [
      // 百家姓 表格
      {
        path: "baijiaxing/biaoge",
        name: "baijiaxing-biaoge",
        meta: {
          requiresAuth: true
        },
        component: baijiaxingBiaoge
      },
      // 百家姓 创建表格
      {
        path: "baijiaxing/createbiaoge",
        name: "baijiaxing-createbiaoge",
        meta: {
          requiresAuth: true
        },
        component: baijiaxingCreateBiaoGe
      },
      // 百家姓 
      {
        path: "baijiaxing/index",
        name: "baijiaxing-index",
        meta: {
          requiresAuth: true
        },
        component: baijiaxingIdex
      },
      // 专题列表
      {
        path: "zhuanti/list",
        name: "zhuanti-list",
        meta: {
          requiresAuth: true,
        },
        component: zhuantiList,
      },
      // 专题首页
      {
        path: "zhuanti/index/:id",
        name: "zhuanti-index",
        meta: {
          requiresAuth: true,
        },
        component: zhuantiIndex,
      },
      // 专题评论
      {
        path: "zhuanticomment/list/:id",
        name: "zhuanticomment-list",
        meta: {
          requiresAuth: true,
        },
        component: zhuanticomment,
      },
      // 匠人资讯
      {
        path: "tradesmanInformation/list",
        name: "tradesmanInformation-list",
        meta: {
          requiresAuth: true,
        },
        component: tradesmanInformation,
      },
      // 首页
      {
        path: "index/index",
        name: "index-index",
        meta: {
          requiresAuth: true,
        },
        component: Main,
      },
      //融宝账号
      {
        path: "reapalapply/list",
        name: "reapalapply-list",
        component: reapalapply,
        meta: {
          requiresAuth: true,
        },
      },

      //园区下的一级分销商 firstagent/list
      {
        path: "parkfirstagent/list/:park_uuid",
        name: "parkfirstagent-list",
        component: ParkFirstAgent,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "salesman/list/:id",
        name: "salesman-list",
        component: Salesman,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "salesmansaoma/list/:uuid",
        name: "salesmansaoma-list",
        component: SalesmanSaomaLog,
        meta: {
          requiresAuth: true,
        },
      },
      //一级分销商 firstagent/list
      {
        path: "firstagent/list/:status",
        name: "firstagent-list",
        component: FirstAgent,
        meta: {
          requiresAuth: true,
        },
      },
      // 一级分销商下的提成记录
      {
        path: "firstagent/tc_record/:id",
        name: "firstagent-tc_record",
        component: FirstAgentTcRecordList,
        meta: {
          requiresAuth: true,
        },
      },
      // 一级分销商下的二级分销商
      {
        path: "firstagent/agent/:id",
        name: "firstagent-agent",
        component: FirstAgentAgent,
        meta: {
          requiresAuth: true,
        },
      },
      // 系统设置
      {
        path: "config/index",
        name: "config-index",
        component: Config,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "appVersionset/index",
        name: "appVersionset-index",
        component: appVersionset,
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: "lists/list",
        name: "lists-list",
        component: Lists,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "listtype/list",
        name: "listtype-list",
        component: ListType,
        meta: {
          requiresAuth: true,
        },
      },
      // 广告位
      {
        path: "adpos/list",
        name: "adpos-list",
        component: AdPos,
        meta: {
          requiresAuth: true,
        },
      },
      // 广告
      {
        path: "ad/list",
        name: "ad-list",
        component: Ad,
        meta: {
          requiresAuth: true,
        },
      },
      // 用户
      {
        path: "admin/list",
        name: "admin-list",
        component: AdminList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "admin/editinfo",
        name: "admin-editinfo",
        component: AdminEditInfo,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "admin/editpwd",
        name: "admin-editpwd",
        component: AdminEditPwd,
        meta: {
          requiresAuth: true,
        },
      },
      // 角色
      {
        path: "role/list",
        name: "role-list",
        component: RoleList,
        meta: {
          requiresAuth: true,
        },
      },
      // 部门
      {
        path: "section/list",
        name: "section-list",
        component: SectionList,
        meta: {
          requiresAuth: true,
        },
      },
      // 权限菜单
      {
        path: "menu/tree",
        name: "menu-tree",
        component: MenuTree,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "tongbucompany/list",
        name: "tongbucompany-list",
        component: Company,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "tongbucompany/goodlist",
        name: "tongbucompany-goodlist",
        component: TongBuGoodOrder,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "exchange/set",
        name: "exchange-set",
        component: ExchangeSet,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "tongbupoints/list",
        name: "tongbupoints-list",
        component: PointsLog,
        meta: {
          requiresAuth: true,
        },
      },
      // 商品列表
      {
        path: "tradgoods/list",
        name: "tradgoods-list",
        component: GoodsList,
        meta: {
          requiresAuth: true,
        },
      },
      // 供应商商品列表
      {
        path: "salegoods/list",
        name: "salegoods-list",
        component: SaleGoods,
        meta: {
          requiresAuth: true,
        },
      },
      // 商品分类
      {
        path: "goodcate/list",
        name: "goodcate-list",
        component: GoodCate,
        meta: {
          requiresAuth: true,
        },
      },
      // 供应商商品分类
      {
        path: "salegoodcate/list",
        name: "salegoodcate-list",
        component: SaleGoodCate,
        meta: {
          requiresAuth: true,
        },
      },
      // 商品品牌
      {
        path: "goodbrand/list",
        name: "goodbrand-list",
        component: GoodBrand,
        meta: {
          requiresAuth: true,
        },
      },
      // 商品属性
      {
        path: "goodattr/list",
        name: "goodattr-list",
        component: GoodAtrr,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "goods/commentlist",
        name: "goods-commentlist",
        component: GoodCommentList,
        meta: {
          requiresAuth: true,
        },
      },
      // 区块链商品生产过程
      {
        path: "good/productprocess",
        name: "good-productprocess",
        component: ProductProcess,
        meta: {
          requiresAuth: true,
        },
      },

      // 普通商品订单
      {
        path: "goods/order/:is_platprice/:pay_status/:ship_status/:order_status",
        name: "goods-order",
        component: GoodsOrder,
        meta: {
          requiresAuth: false,
        },
      },
      //供应商商品订单
      {
        path: "salegoods/order/:is_platprice/:pay_status/:ship_status/:order_status",
        name: "salegoods-order",
        component: GoodsOrder,
        meta: {
          requiresAuth: false,
        },
      },
      // 园区订单
      {
        path: "parkgoods/order/:is_platprice/:pay_status/:ship_status/:order_status",
        name: "parkgoods-order",
        component: GoodsOrder,
        meta: {
          requiresAuth: false,
        },
      },
      // 自提商品订单
      {
        path: "goods/ztorder/:is_platprice/:pay_status/:order_status",
        name: "goods-ztorder",
        component: GoodsZtOrder,
        meta: {
          requiresAuth: true,
        },
      },
      // 供应商自提商品订单
      {
        path: "salegoods/ztorder/:is_platprice/:pay_status/:order_status",
        name: "salegoods-ztorder",
        component: GoodsZtOrder,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区自提商品订单
      {
        path: "parkgoods/ztorder/:is_platprice/:pay_status/:order_status",
        name: "parkgoods-ztorder",
        component: GoodsZtOrder,
        meta: {
          requiresAuth: true,
        },
      },
      // b2c商品退货订单
      {
        path: "b2cordergood/list/:is_platprice/:status",
        name: "b2cordergood-list",
        component: ReturnOrder,
        meta: {
          requiresAuth: true,
        },
      },
      // b2b商品退货订单
      {
        path: "b2bordergood/list/:is_platprice/:status",
        name: "b2bordergood-list",
        component: ReturnOrder,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区商品退货订单
      {
        path: "parkordergood/list/:is_platprice/:status",
        name: "parkordergood-list",
        component: ReturnOrder,
        meta: {
          requiresAuth: true,
        },
      },
      // 快递列表
      {
        path: "logistics/list",
        name: "logistics-list",
        component: LogisticList,
        meta: {
          requiresAuth: true,
        },
      },
      // 经销商发票规则
      {
        path: "saleinvoice/list",
        name: "saleinvoice-list",
        component: SaleInvoiceRule,
        meta: {
          requiresAuth: true,
        },
      },
      // 会员
      {
        path: "user/list",
        name: "user-list",
        component: UserList,
        meta: {
          requiresAuth: true,
        },
      },
      // 会员发票
      {
        path: "userinvoice/list/:uuid",
        name: "userinvoice-list",
        component: UserInvoice,
        meta: {
          requiresAuth: true,
        },
      },
      // 会员消费
      {
        path: "user/consume/list/:id",
        name: "user/consume-list",
        component: UserConsume,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "user/concellog/list",
        name: "user/concellog-list",
        component: ConcelLog,
        meta: {
          requiresAuth: true,
        },
      },
      // 会员地址
      {
        path: "user/address/list/:id",
        name: "user/address-list",
        component: UserAddress,
        meta: {
          requiresAuth: true,
        },
      },
      // 会员分组
      {
        path: "user/group/list",
        name: "user-group-list",
        component: UserGroup,
        meta: {
          requiresAuth: true,
        },
        //
      },
      // 匠人分类
      {
        path: "tradesman/catelist",
        name: "tradesman-catelist",
        component: TradesmanCateList,
        meta: {
          requiresAuth: true,
        },
      },
      // 匠人图集分类
      {
        path: "tradesman/thumbcatelist",
        name: "tradesman-thumbcatelist",
        component: TradesmanThumbCateList,
        meta: {
          requiresAuth: true,
        },
      },
      // 匠人图集
      {
        path: "tradesman/thumblist",
        name: "tradesman-thumblist",
        component: TradesmanThumbList,
        meta: {
          requiresAuth: true,
        },
      },
      // 匠人图集评论
      {
        path: "tradesman/thumbcommentlist/:id",
        name: "tradesman-thumbcommentlist",
        component: TradesmanThumbCommentList,
        meta: {
          requiresAuth: true,
        },
      },
      // 匠人技艺
      {
        path: "tradesman/skilllist",
        name: "tradesman-skilllist",
        component: TradesmanSkillList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "tradesman/sorcelist",
        name: "tradesman-sorcelist",
        component: TradesmanSorce,
        meta: {
          requiresAuth: true,
        },
      },
      // 匠人
      {
        path: "registertradesman/list/:register_status",
        name: "tradesman-list",
        component: TradesmanList,
        meta: {
          requiresAuth: true,
        },
      },
      // 待注册匠人
      {
        path: "unregistertradesman/list/:register_status",
        name: "tradesman-list",
        component: TradesmanList,
        meta: {
          requiresAuth: true,
        },
      },
      // 待审匠人
      {
        path: "reviewtradesman/list",
        name: "reviewtradesman-list",
        component: ReviewTradesmanList,
        meta: {
          requiresAuth: true,
        },
      },
      // 供应商
      {
        path: "seller/list/:status",
        name: "seller-list",
        component: SellerList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "agents/list/:status",
        name: "agents-list",
        component: Agents,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "agents/qrcodes/:user_uuid",
        name: "agents-qrcodes",
        component: QrcodeUser,
        meta: {
          requiresAuth: true,
        },
      },
      // 代理商下的用户列表
      {
        path: "agents/userlist/:id",
        name: "agents-userlist",
        component: AgentsUserList,
        meta: {
          requiresAuth: true,
        },
      },
      // 代理商下的商户列表
      {
        path: "agents/tradesman/:id",
        name: "agents-tradesman",
        component: AgentsTradesmanList,
        meta: {
          requiresAuth: true,
        },
      },
      // 代理商提成记录
      {
        path: "agents/tc_record/:id",
        name: "agents-tc_record",
        component: AgentsTcRecordList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "partners/list/:status",
        name: "partners-list",
        component: Partners,
        meta: {
          requiresAuth: true,
        },
      },
      // 城市合伙人下的代理商列表
      {
        path: "partners/agent/:id",
        name: "partners-agent",
        component: PartnersAgent,
        meta: {
          requiresAuth: true,
        },
      },
      // 城市合伙人下的商户列表
      {
        path: "partners/tradesman/:id",
        name: "partners-tradesman",
        component: PartnersTradesmanList,
        meta: {
          requiresAuth: true,
        },
      },
      // 城市合伙人下的提成记录
      {
        path: "partners/tc_record/:id",
        name: "partners-tc_record",
        component: PartnersTcRecordList,
        meta: {
          requiresAuth: true,
        },
      },
      // 项目相关
      {
        path: "intangibleCate/list",
        name: "intangibleCate-list",
        component: IntangibleCate,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "intangibleLevel/list",
        name: "intangibleLevel-list",
        component: IntangibleLevel,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "itemtype/list",
        name: "itemtype-list",
        component: ItemType,
        meta: {
          requiresAuth: false,
        },
      },
      // 非遗
      {
        path: "intangibleItem/fylist/:id",
        name: "intangibleItem-fylist",
        component: IntangibleItem,
        meta: {
          requiresAuth: false,
        },
      },
      // 乡村
      {
        path: "intangibleItem/xclist/:id",
        name: "intangibleItem-xclist",
        component: IntangibleItem,
        meta: {
          requiresAuth: false,
        },
      },
      // 民宿
      {
        path: "intangibleItem/mslist/:id",
        name: "intangibleItem-mslist",
        component: IntangibleItem,
        meta: {
          requiresAuth: false,
        },
      },
      // 景区
      {
        path: "intangibleItem/jqlist/:id",
        name: "intangibleItem-jqlist",
        component: IntangibleItem,
        meta: {
          requiresAuth: false,
        },
      },
      // 农特
      {
        path: "intangibleItem/ntlist/:id",
        name: "intangibleItem-ntlist",
        component: IntangibleItem,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "intangibleLocation/list/:id",
        name: "intangibleLocation-list",
        component: IntangibleLocation,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "locationErrors/list",
        name: "locationErrors-list",
        component: LocationErrors,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "locationComments/list",
        name: "locationComments-list",
        component: LocationComments,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "intangibleCommon/area",
        name: "intangibleCommon-area",
        component: Area,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "noteConfig/detail",
        name: "noteConfig-detail",
        component: NoteConfig,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "locationNote/list",
        name: "locationNote-list",
        component: LocationNote,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "bigmap/hotLocations",
        name: "bigmap-hotLocations",
        component: HotItemLocation,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "bigmap/getHeatArea",
        name: "bigmap-getHeatArea",
        component: HeatArea,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "staffGroup/list",
        name: "staffGroup-list",
        component: StaffGroup,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "staff/list",
        name: "staff-list",
        component: Staff,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "chargecard/list",
        name: "chargecard-list",
        component: ChargeCard,
        meta: {
          requiresAuth: false,
        },
      },
      // 热门搜索
      {
        path: "search/data",
        name: "search-data",
        component: SearchData,
        meta: {
          requiresAuth: false,
        },
      },
      // 专题
      {
        path: "special/list",
        name: "special-list",
        component: Special,
        meta: {
          requiresAuth: false,
        },
      },
      // 专题选择匠人
      {
        path: "specialtrad/list/:params",
        name: "specialtrad-list",
        component: SpecialTrad,
        meta: {
          requiresAuth: false,
        },
      },
      // 商家后台--菜单
      {
        path: "merchant/menu/list",
        name: "merchant-menu-list",
        component: merchantMenuList,
        meta: {
          requiresAuth: false,
        },
      },
      // 角色
      {
        path: "merchantrole/list",
        name: "merchantrole-list",
        component: merchantRoleList,
        meta: {
          requiresAuth: false,
        },
      },
      // 约看
      {
        path: "lives/list",
        name: "lives-list",
        component: Lives,
        meta: {
          requiresAuth: false,
        },
      },
      // 视频分类
      {
        path: "liveroomType/list",
        name: "liveroomType-list",
        component: LiveRoomType,
        meta: {
          requiresAuth: false,
        },
      },
      // 约看分类
      {
        path: "livesType/list",
        name: "livesType-list",
        component: LivesType,
        meta: {
          requiresAuth: false,
        },
      },
      // 约看订单
      {
        path: "lives/orderlist/:pay_status/:ship_status/:status",
        name: "lives-orderlist",
        component: LivesOrder,
        meta: {
          requiresAuth: false,
        },
      },
      // 提现记录
      {
        path: "applylog/list",
        name: "applylog-list",
        component: Applylog,
        meta: {
          requiresAuth: true,
        },
      },
      // 匠人记录
      {
        path: "tradmoney/list/:is_park",
        name: "tradmoney-list",
        component: TradMoneylog,
        meta: {
          requiresAuth: true,
        },
      },
      // 供应商收入记录
      {
        path: "sellermoney/list",
        name: "sellermoney-list",
        component: SellerMoneylog,
        meta: {
          requiresAuth: true,
        },
      },
      // 单页
      {
        path: "pages/list",
        name: "pages-list",
        component: Pages,
        meta: { requiresAuth: true },
      },
      {
        path: "qrcodes/list",
        name: "qrcodes-list",
        component: Qrcode,
        meta: { requiresAuth: true },
      },
      {
        path: "pages/create",
        name: "pages-create",
        component: PagesCreate,
        meta: { requiresAuth: true },
      },
      {
        path: "pages/edit",
        name: "pages-edit",
        component: PagesCreate,
        meta: { requiresAuth: true },
      },
      // 园区
      {
        path: "park/list",
        name: "park-list",
        component: ParkList,
        meta: { requiresAuth: true },
      },
      // 园区收入统计
      {
        path: "park/MoneyStatistics/:id",
        name: "park-MoneyStatistics",
        component: ParkMoneyStatistics,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区等级规则
      {
        path: "park/levellist/:park_uuid",
        name: "park-levellist",
        component: ParkLevelList,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区下的商户列表
      {
        path: "park/tradesman/:id",
        name: "park-tradesman",
        component: ParkTradesmanList,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区下的未审核商户列表
      {
        path: "park/pendtradesman",
        name: "park-pendtradesman",
        component: ParkPendTradList,
        meta: {
          requiresAuth: true,
        },
      },
      //
      {
        path: "park/tc_record/:id",
        name: "park-tc_record",
        component: ParkTcRecordList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "park/txlist/:id",
        name: "park-txlist",
        component: ParkTxList,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区下代理商
      {
        path: "park/agentList/:id",
        name: "park-agentList",
        component: ParkAgent,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区下的未审核代理商列表
      {
        path: "park/pendingagent",
        name: "park-pendingagent",
        component: ParkPendAgent,
        meta: {
          requiresAuth: true,
        },
      },
      // 园区下的未审核一级分销商列表
      {
        path: "park/pendingfirstagent",
        name: "park-pendingfirstagent",
        component: ParkPendFirstAgent,
        meta: {
          requiresAuth: true,
        },
      },
      //直播
      {
        path: "liveRoom/list",
        name: "liveRoom-list",
        component: LiveRoomList,
        meta: {
          requiresAuth: true,
        },
      },
      //直播回放
      {
        path: "liveRoom/callback/:id",
        name: "liveRoom-callback",
        component: LiveRoomCallBack,
        meta: {
          requiresAuth: true,
        },
      },
      //回放评论
      {
        path: "callback/comment/:id",
        name: "callback-comment",
        component: LiveRoomCallBackComment,
        meta: {
          requiresAuth: true,
        },
      },
      //文件导出列表
      {
        path: "excel/list",
        name: "excel-list",
        component: ExcelExport,
        meta: {
          requiresAuth: true,
        },
      },
      //视频
      {
        path: "liveVideos/list",
        name: "liveVideo-list",
        component: LiveVideoList,
        meta: {
          requiresAuth: true,
        },
      },
      // 视频章节
      {
        path: "liveVideosChapter/list/:id",
        name: "liveVideo-list",
        component: LiveVideosChapter,
        meta: {
          requiresAuth: true,
        },
      },
      //视频订单
      {
        path: "LivesVideoOrder/list",
        name: "LivesVideoOrder-list",
        component: LivesVideoOrder,
        meta: {
          requiresAuth: true,
        },
      },
      //定制分类 CustomMadeCate
      {
        path: "custommadecate/list",
        name: "custommadecate-list",
        component: CustomMadeCate,
        meta: {
          requiresAuth: true,
        },
      },
      //定制 CustomMade
      {
        path: "custommade/list",
        name: "custommade-list",
        component: CustomMade,
        meta: {
          requiresAuth: true,
        },
      },
      //定制订单
      {
        path: "madeorder/list/:pay_status/:ship_status/:order_status",
        name: "madeorder-list",
        component: MadeOrder,
        meta: {
          requiresAuth: true,
        },
      },
      //定制评论
      {
        path: "customcomment/list/:made_id",
        name: "customcomment-list",
        component: MadeComment,
        meta: {
          requiresAuth: true,
        },
      },
      //定制社区
      {
        path: "customcommunity/list",
        name: "customcommunity-list",
        component: CustomCommunity,
        meta: {
          requiresAuth: true,
        },
      },
      //头条推荐类型
      {
        path: "headlinepush/list",
        name: "headlinepush-list",
        meta: {
          requiresAuth: true,
        },
        component: HeadlinePushType,
      },
      //头条分类
      {
        path: "headlinecate/list",
        name: "headlinecate-list",
        meta: {
          requiresAuth: true,
        },
        component: HeadlineCate,
      },
      //头条
      {
        path: "headline/list",
        name: "headline-list",
        meta: {
          requiresAuth: true,
        },
        component: Headline,
      },
      //头条评论
      {
        path: "headline/commentlist",
        name: "headline-commentlist",
        meta: {
          requiresAuth: true,
        },
        component: HeadlineCommentList,
      },
      //历史的今天分类
      {
        path: "historycate/list",
        name: "historycate-list",
        meta: {
          requiresAuth: true,
        },
        component: Historycate,
      },
      //历史的今天
      {
        path: "history/list",
        name: "history-list",
        meta: {
          requiresAuth: true,
        },
        component: History,
      },
      //历史的今天评论
      {
        path: "history/commentlist",
        name: "history-commentlist",
        meta: {
          requiresAuth: true,
        },
        component: HistoryComment,
      },
      //历史的今天道具
      {
        path: "historydaoju/list",
        name: "historydaoju-list",
        meta: {
          requiresAuth: true,
        },
        component: HistoryDaoJu,
      },
      //漂流
      {
        path: "lovedrift/list",
        name: "lovedrift-list",
        meta: {
          requiresAuth: true,
        },
        component: LoveDrift,
      },
      //漂流瓶评论
      {
        path: "lovedrift/commentlist",
        name: "lovedrift-commentlist",
        meta: {
          requiresAuth: true,
        },
        component: LoveDriftComment,
      },
      //海报
      {
        path: "poster/list",
        name: "poster-list",
        meta: {
          requiresAuth: true,
        },
        component: Poster,
      },
      // 消息 - 系统消息
      {
        path: "msg/system/list",
        name: "msg-system-list",
        meta: {
          requiresAuth: true,
        },
        component: systemMsg,
      },
      // 消息 - 客服消息
      {
        path: "msg/customer/list",
        name: "msg-customer-list",
        meta: {
          requiresAuth: true,
        },
        component: customerMsg,
      },

      // 举报
      {
        path: "report/list",
        name: "report-list",
        meta: {
          requiresAuth: true,
        },
        component: report,
      },
      // 献礼 - 支持单位
      {
        path: "xlisupportunit/list",
        name: "xlisupportunit-list",
        meta: {
          requiresAuth: true,
        },
        component: XliSupportUnit,
      },
      // 献礼 - 外链
      {
        path: "xlilinks/list",
        name: "xlilinks-list",
        meta: {
          requiresAuth: true,
        },
        component: XliLinks,
      },
      // 献礼 - 文章
      {
        path: "xliarticle/list",
        name: "xliarticle-list",
        meta: {
          requiresAuth: true,
        },
        component: XliArticle,
      },
      // 献礼 - 评论
      {
        path: "xliarticlecomment/list/:id",
        name: "xliarticlecomment-list",
        meta: {
          requiresAuth: true,
        },
        component: XliArticleComment,
      },
      // 智慧园区
      {
        path: "smartvenue/list",
        name: "smartvenue-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartVenue,
      },
      {
        path: "smarttickettype/list",
        name: "smarttickettype-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartTicketType,
      },
      {
        path: "smartticket/list/:id",
        name: "smartticket-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartTicket,
      },
      {
        path: "smartthroughticket/list",
        name: "smartthroughticket-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartThroughTicket,
      },
      {
        path: "studycontent/list",
        name: "studycontent-list",
        meta: {
          requiresAuth: true,
        },
        component: StudyContent,
      },
      {
        path: "studygroup/list",
        name: "studygroup-list",
        meta: {
          requiresAuth: true,
        },
        component: StudyGruop,
      },
      {
        path: "venueproduct/list",
        name: "venueproduct-list",
        meta: {
          requiresAuth: true,
        },
        component: VenueProduct,
      },
      {
        path: "screen/infomation",
        name: "screen-infomation",
        meta: {
          requiresAuth: true,
        },
        component: SmartParkScreen,
      },
      {
        path: "teamtype/list",
        name: "teamtype-list",
        meta: {
          requiresAuth: true,
        },
        component: TeamType,
      },
      {
        path: "smartticketprice/list/:id",
        name: "smartticketprice-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartTicketPrice,
      },
      {
        path: "smartservice/list",
        name: "smartservice-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartService,
      },
      {
        path: "smartreceper/list",
        name: "smartreceper-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartReceper,
      },
      {
        path: "smartorder/list",
        name: "smartorder-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartOrder,
      },
      {
        path: "timecardorder/list",
        name: "timecardorder-list",
        meta: {
          requiresAuth: true,
        },
        component: TimeCardOrder,
      },
      {
        path: "smartuserorder/list",
        name: "smartuserorder-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartUserOrder,
      },
      {
        path: "smartenterinfoset/list",
        name: "smartenterinfoset-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartEnterinfo,
      },
      {
        path: "smartTimesCard/list",
        name: "smartTimesCard-list",
        meta: {
          requiresAuth: true,
        },
        component: TimesCard,
      },
      {
        path: "smartpark/list",
        name: "smartpark-list",
        meta: {
          requiresAuth: true,
        },
        component: SmartPark,
      },
      {
        path: "ticketcollector/list",
        name: "ticketcollector-list",
        meta: {
          requiresAuth: true,
        },
        component: TicketCollector,
      },
      {
        path: "appVersion/list",
        name: "appVersion-list",
        meta: {
          requiresAuth: true,
        },
        component: AppVersion,
      },
      {
        path: "hechengpoolgood/list/:rule_id",
        name: "hechengpoolgood-list",
        meta: {
          requiresAuth: true,
        },
        component: HechengPoolGood,
      },
      {
        path: "hechengpooldata/list",
        name: "hechengpooldata-list",
        meta: {
          requiresAuth: true,
        },
        component: HechengPoolData,
      },
      {
        path: "hechengpoolprobability/list/:rule_id",
        name: "hechengpoolprobability-list",
        meta: {
          requiresAuth: true,
        },
        component: HechengPoolProbability,
      },
      {
        path: "hechengpoolrule/list",
        name: "hechengpoolrule-list",
        meta: {
          requiresAuth: true,
        },
        component: HechengPoolRule,
      },
      {
        path: "productpoolgood/list/:pool_id",
        name: "productpoolgood-list",
        meta: {
          requiresAuth: true,
        },
        component: ProductPoolGood,
      },
      {
        path: "productpool/probability",
        name: "productpool-probability",
        meta: {
          requiresAuth: true,
        },
        component: ProductPoolProbability,
      },
      {
        path: "productpool/list",
        name: "productpool-list",
        meta: {
          requiresAuth: true,
        },
        component: ProductPool,
      },
      {
        path: "productpoolcate/list/:pool_id",
        name: "productpoolcate-list",
        meta: {
          requiresAuth: true,
        },
        component: ProductPoolCate,
      },
      {
        path: "data/list",
        name: "data-list",
        meta: {
          requiresAuth: true,
        },
        component: Data,
      },
      {
        path: "winner/list",
        name: "winner-list",
        meta: {
          requiresAuth: true,
        },
        component: Winner,
      },
      {
        path: "boxorder/list/:pay_status/:order_status",
        name: "boxorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheOrder,
      },
      {
        path: "manghegoodorder/list/:ship_status/:order_status",
        name: "manghegoodorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheGoodsOrder,
      },
      {
        path: "manghemadegoodorder/list/:ship_status/:order_status",
        name: "manghemadegoodorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheMadeGoodsOrder,
      },
      {
        path: "manghedataorder/list",
        name: "manghedataorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheDataOrder,
      },
      {
        path: "mangherecoveryorder/list",
        name: "mangherecoveryorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheHuishouOrder,
      },
      {
        path: "manghefareorder/list",
        name: "manghefareorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheFareOrder,
      },
      {
        path: "manghecolor/list",
        name: "manghecolor-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheColor,
      },
      {
        path: "manghewish/list",
        name: "manghewish-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheWish,
      },
      {
        path: "manghemadeorder/list/:pay_status/:status",
        name: "manghemadeorder-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheMadeOrder,
      },
      {
        path: "manghehomecolor/list",
        name: "manghehomecolor-list",
        meta: {
          requiresAuth: true,
        },
        component: MangheHomeColor,
      },

      {
        path: "numprocate/list",
        name: "numprocate-list",
        meta: {
          requiresAuth: true,
        },
        component: NumproCate,
      },
      {
        path: "product/list",
        name: "product-list",
        meta: {
          requiresAuth: true,
        },
        component: Product,
      },
      {
        path: "showroom/list",
        name: "showroom-list",
        meta: {
          requiresAuth: true,
        },
        component: ShowRoom,
      },
      {
        path: "collectionchain/list",
        name: "collectionchain-list",
        meta: {
          requiresAuth: true,
        },
        component: CollectionChain,
      },
      {
        path: "uncollectionchain/list",
        name: "uncollectionchain-list",
        meta: {
          requiresAuth: true,
        },
        component: UnCollectionChain,
      },
      {
        path: "collector/list",
        name: "collector-list",
        meta: {
          requiresAuth: true,
        },
        component: Collector,
      },
      {
        path: "collectionorder/list",
        name: "collectionorder-list",
        meta: {
          requiresAuth: true,
        },
        component: CollectionOrder,
      },
      {
        path: "turnlog/list",
        name: "turnlog-list",
        meta: {
          requiresAuth: true,
        },
        component: TurnLog,
      },
      {
        path: "exchange/list",
        name: "exchange-list",
        meta: {
          requiresAuth: true,
        },
        component: Exchange,
      },
      {
        path: "collectorrecord/list",
        name: "collectorrecord-list",
        meta: {
          requiresAuth: true,
        },
        component: CollectorRecord,
      },
      {
        path: 'operator/list',
        name: 'operator-list',
        meta: {
          requiresAuth: true
        },
        component: Operator
      },
      {
        path: 'chouqurule/getgoodrule',
        name: 'chouqurule-getgoodrule',
        meta: {
          requiresAuth: true
        },
        component: ChouQuRule
      },
      {
        path: 'baixingqiang/arealist',
        name: 'baixingqiang-arealist',
        meta: {
          requiresAuth: true
        },
        component: BaiXingQiang
      },
      {
        path: 'mangheqianggoodorder/payorderlist/:pay_status/:order_status',
        name: 'mangheqianggoodorder-payorderlist',
        meta: {
          requiresAuth: true
        },
        component: BaiXingQiangPayOrder
      },
      {
        path: 'mangheqianggoodorder/list/:ship_status/:order_status',
        name: 'mangheqianggoodorder-list',
        meta: {
          requiresAuth: true
        },
        component: BaiXingQiangGoodOrder
      },
      {
        path: 'qiangset/list',
        name: 'qiangset-list',
        meta: {
          requiresAuth: true
        },
        component: BaiXingQiangSet
      },
      {
        path: 'mangheqianggoodreturnorder/list/:status',
        name: 'mangheqianggoodreturnorder-list',
        meta: {
          requiresAuth: true
        },
        component: MangheQiangGoodReturnOrder
      },
      {
        path: "type/list",
        name: "type-list",
        meta: {
          requiresAuth: true,
        },
        component: Type,
      },

      {
        path: "media/category",
        name: "media-category",
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
        component: mediaCategory,
      },
      {
        path: "media/index",
        name: "media-index",
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
        component: mediaIndex,
      },

      {
        path: 'fareset/detail',
        name: 'fareset-detail',
        meta: {
          requiresAuth: true
        },
        component: SetFare
      },
      {
        path: 'goodattrtag/list',
        name: 'goodattrtag-list',
        meta: {
          requiresAuth: true
        },
        component: GoodAtrrtag
      },


      {
        path: 'notice/list',
        name: 'notice-list',
        meta: {
          requiresAuth: true
        },
        component: Notice
      },
      {
        path: 'mangheshopgoodcate/list',
        name: 'mangheshopgoodcate-list',
        meta: {
          requiresAuth: true
        },
        component: MangheShopCate
      },
      {
        path: 'mangheshopgoods/list',
        name: 'mangheshopgoods-list',
        meta: {
          requiresAuth: true
        },
        component: MangheShopGoods
      },
      {
        path: 'mangheshopgoodorder/list/:ship_status/:order_status',
        name: 'mangheshopgoodorder-list',
        meta: {
          requiresAuth: true
        },
        component: MangheShopGoodOrder
      },
      {
        path: 'mangheshopgoodreturnorder/list/:status',
        name: 'mangheshopgoodreturnorder-list',
        meta: {
          requiresAuth: true
        },
        component: MangheShopGoodReturnOrder
      },
      {
        path: 'mangheshopgoodorder/payorderlist/:pay_status/:order_status',
        name: 'mangheshopgoodorder-payorderlist',
        meta: {
          requiresAuth: true
        },
        component: MangheShopPayOrder
      },
      {
        path: 'mangheshop/set',
        name: 'mangheshop-set',
        meta: {
          requiresAuth: true
        },
        component: ShopSet
      },
      {
        path: 'mangheshopgoodkeyword/list',
        name: 'mangheshopgoodkeyword-list',
        meta: {
          requiresAuth: true
        },
        component: ShopKeyword
      },
      {
        path: 'mangheset/detail',
        name: 'mangheset-detail',
        meta: {
          requiresAuth: true
        },
        component: MangheSet
      },

      // 其它404
      {
        path: '*',
        name: 'noaccess',
        meta: {
          requiresAuth: true
        },
        component: Nofound
      }
    ]
  }]
